import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { formatCurrency } from '../utils/calculations';

const { FiAlertCircle, FiCheckCircle, FiInfo } = FiIcons;

function Insights({ calculations, settings }) {
  const insights = [];

  if (calculations.remaining < 0) {
    insights.push({
      icon: FiAlertCircle,
      tone: 'warning',
      title: 'Plan exceeds the approved budget',
      text: `Reduce selected inventory by ${formatCurrency(
        Math.abs(calculations.remaining)
      )} or request a revised authorization.`
    });
  } else {
    insights.push({
      icon: FiCheckCircle,
      tone: 'success',
      title: 'Plan is within the approved budget',
      text: `${formatCurrency(
        calculations.remaining
      )} remains available for negotiations or late-stage opportunities.`
    });
  }

  if (settings.contingencyRate < 5) {
    insights.push({
      icon: FiAlertCircle,
      tone: 'warning',
      title: 'Contingency may be too low',
      text: 'Medical meetings often incur venue, freight, labor, or production changes. Consider a reserve of at least 5%.'
    });
  }

  insights.push({
    icon: FiInfo,
    tone: 'info',
    title: 'Document compliance review',
    text: 'Confirm society policies, fair-market-value requirements, content review timelines, and applicable industry codes before purchase.'
  });

  return (
    <section className="panel insights-panel">
      <div className="section-heading">
        <div>
          <span className="section-kicker">Planning guidance</span>
          <h2>Budget checks</h2>
        </div>
      </div>

      <div className="insight-list">
        {insights.map((insight) => (
          <article className={`insight ${insight.tone}`} key={insight.title}>
            <SafeIcon icon={insight.icon} />
            <div>
              <strong>{insight.title}</strong>
              <p>{insight.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Insights;